import { designTokens, type InterfaceColorMode } from "./tokens.js";

/** Blueprint chrome and node frames only; port colors retain their type semantics. */
export function behaviorPresentation(mode: InterfaceColorMode) {
  const p = designTokens[mode];
  return {
    background: p.background,
    color: p.text,
    "& [data-behavior-palette]": {
      width: "218px",
      minWidth: "218px",
      maxWidth: "218px",
      backgroundColor: p.chrome,
      borderColor: p.border,
      "& > .MuiBox-root:first-of-type": {
        backgroundColor: p.chrome,
        borderColor: p.border,
        py: 1.5,
      },
      "& .MuiTypography-subtitle2": {
        fontSize: 11,
        textTransform: "uppercase",
        letterSpacing: ".8px",
      },
      "& .MuiAccordion-root": { backgroundColor: "transparent" },
      "& .MuiAccordionSummary-root": { minHeight: 30 },
      "& .MuiOutlinedInput-root": { fontSize: 11 },
      "& button[draggable]": {
        fontSize: 11,
        marginLeft: 0,
        borderRadius: "5px",
        padding: "6px 8px",
      },
    },
    "& [data-behavior-canvas]": {
      backgroundColor: `${p.background} !important`,
      backgroundImage: `radial-gradient(${p.border} 1px, transparent 1px) !important`,
    },
    "& [data-node-root] > div": {
      background: `${p.surface} !important`,
      color: p.text,
      border: `1px solid ${p.border} !important`,
      boxShadow: "0 2px 8px rgba(0,0,0,.08) !important",
      borderRadius: "8px !important",
    },
    "& [data-node-root] > div > div:first-child": {
      background: `${p.chrome} !important`,
      color: `${p.text} !important`,
      borderBottom: `1px solid ${p.fine}`,
      borderLeft: "3px solid var(--behavior-node-accent)",
      padding: "8px 10px !important",
      fontSize: "11px !important",
    },
    "& [data-node-root] .MuiOutlinedInput-root": {
      fontSize: 11,
      backgroundColor: p.background,
    },
  };
}
